module.exports = __webpack_public_path__ + "9ebe20a4f22e2aab6e7d5d1e3955056e.svg";